/**
 * Because risk score ascends in greater health, but risk class ascends in worst health,
 * we need to reflect the risk class across the scale to get the risk score
 * reflection = (num_of_points + 1) - risk_class
 */
export function getRiskScoreFromRiskClass(
  riskClass: number | undefined
): number | undefined {
  if (riskClass === undefined || riskClass === 0) {
    return undefined
  }
  return 5 - riskClass
}

export function getRiskClassFromRiskScore(
  riskScore: number | undefined
): number | undefined {
  if (riskScore === undefined) {
    return undefined
  }

  if (riskScore < 1) {
    return 1
  }

  return 5 - riskScore
}
